query MfaSessionScans($runId: ConditionID!, $scanNameFilter: ConditionString) {
	scans(run_id_eq: $runId, scan_name_eq: $scanNameFilter) {
		scan_id
		created_at
	}
}

